module.exports = {
  // The only reason we're keeping this file around is because the backend font
  // file detail page uses it for the tabs at the bottom of the page.
  //
  // For example:
  //   /variations/33852/files/1000055569
  FamilyDetailView: require('./family_detail_view'),

  // Keep this around for the filters sidebar in the backend
  //
  // For example:
  //   /backend/vendors/169/families/ldwz
  Filters: require('./filters')
};
